import React, { Fragment, useMemo } from 'react'
import styles from './styles.module.css'
import { isNumber, uniqueId } from 'lodash'
import * as Flags from 'country-flag-icons/react/3x2'

const SubIndexTooltip = ({
  active,
  payload,
  show = false,
}: {
  active: boolean
  payload: any
  label: string
  show: boolean
}) => {
  const Flag = Flags[payload?.[0]?.payload?.countryCode as keyof typeof Flags]
  const totalScore = useMemo(() => {
    const scoreSum = payload?.reduce((prev: number, curr: any) => {
      let tempScore = prev
      if (isNumber(curr?.value) && curr.value >= 0) {
        tempScore += Number(curr?.value)
      }
      return tempScore
    }, 0)
    return scoreSum?.toFixed(2)
  }, [payload])

  if (!show) return
  if (active && payload && payload.length >= 2) {
    return (
      <div className='custom-tooltip'>
        <div className={styles.span}>
          <div className={styles.totalScoreContainer}>
            <Flag width={24} />
            <span className={styles.totalScore}>{`Total Score: ${totalScore}`}</span>
          </div>
          {/* {payload.map((p: any) => (
            <Fragment key={uniqueId('tooltip_payload_')}>
              {`${p.name}: ${p.value?.toFixed(2)}`}
              <br />
            </Fragment>
          ))} */}
        </div>
      </div>
    )
  } else {
    return (
      <div className='custom-tooltip'>
        {/* <span className={styles.span}>
          {`Click on an individual country to visit that country's profile`}
          <br />
          {`Score: ${parseFloat(payload[0]?.value).toFixed(2)}`}
        </span>
        . */}
        <div className={styles.span}>
          {`Click on an individual country to visit that country's profile`}
          <br />
          {`Score: ${parseFloat(payload[0]?.value).toFixed(2)}`}
        </div>
      </div>
    )
  }
}
export default SubIndexTooltip
